import { render, staticRenderFns } from "./MealDetails.vue?vue&type=template&id=dccb636a&scoped=true"
import script from "./MealDetails.vue?vue&type=script&lang=js"
export * from "./MealDetails.vue?vue&type=script&lang=js"
import style0 from "./MealDetails.vue?vue&type=style&index=0&id=dccb636a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dccb636a",
  null
  
)

export default component.exports